import Content from 'lib/Content';
import localforage from 'localforage';
import memoryStorageDriver from 'localforage-memoryStorageDriver';

import { fetchGlobalSettings } from 'state/actions/ui/applicationUIActions';

export const INITIALIZE_APPLICATION = 'INITIALIZE_APPLICATION';
export const initializeApplication = () => (dispatch) => {
  return dispatch({
    type: INITIALIZE_APPLICATION,
    payload: new Promise(async (resolve, reject) => {
      try {
        console.log('init app');

        const presetup = [
          localforage.defineDriver(memoryStorageDriver).then(() => {
            return localforage.config({
              driver: [
                localforage.INDEXEDDB,
                localforage.WEBSQL,
                localforage.LOCALSTORAGE,
                memoryStorageDriver._driver
              ]
            });
          })
        ];

        await Promise.all(presetup);

        // We don't await this because if the contentful API fails
        // with a 402 (Payment Required), it actually fails at the
        // preflight (CORS) step, which doesn't cause a promise rejection,
        // meaning our application will show the loader indefinitely.
        // Instead, we just let it fail silently fallback to the 
        // hardcoded default menu.
        dispatch(fetchGlobalSettings());

        resolve();
      } catch (e) {
        console.log(e);
        reject(e);
      }
    })
  });
};
